import React from 'react';
import * as classNames from 'classnames';
import ListAthletesItemAthleteScoreRouteItem from './ListAthletesItemAthleteScoreRouteItem';
import ListAthletesItemAthleteScoreRouteItemLoading from './ListAthletesItemAthleteScoreRouteItemLoading';
var selfStyles = require('./styles.scss');
var ListAthletesItemAthleteScoreRoutes = function (props) {
    var athleteScoreRouteList = !props.athleteScoreRoutes || props.athleteScoreRoutes.length < props.round.routeCount
        ? Array(props.round.routeCount)
            .fill(0)
            .map(function (v, i) { return React.createElement(ListAthletesItemAthleteScoreRouteItemLoading, { key: i, width: props.width }); })
        : props.athleteScoreRoutes
            .sort(function (a, b) { return a.index - b.index; })
            .map(function (sR) { return (React.createElement(ListAthletesItemAthleteScoreRouteItem, { key: sR.id, athleteScoreRoute: sR, isPlatform: props.isPlatform, width: props.width, onClick: function () { props.handleChangeAthleteScoreRoute(sR.id); } })); });
    return (React.createElement("div", { className: classNames(selfStyles.athleteScoreRoute, (_a = {},
            _a[selfStyles.athleteScoreRouteOverflow] = props.width !== 0,
            _a)) }, athleteScoreRouteList));
    var _a;
};
export default ListAthletesItemAthleteScoreRoutes;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemAthleteScoreRoutes.tsx
// module id = 1021
// module chunks = 0